// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5o-5";
export var imageContainer = "_5o-4";
export var metricsGrid = "_5o-2";
export var productDetailContainer = "_5o-1";
export var productListContainer = "_5o-0";
export var subscriberTableContainer = "_5o-3";